"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TWICE_MONTH = exports.ALTERNATE_WEEKS = exports.MONTH = exports.WEEK = void 0;
exports.WEEK = "weekly";
exports.MONTH = "month";
exports.ALTERNATE_WEEKS = "alternate_weeks";
exports.TWICE_MONTH = "twice_month";